

export enum PmsRoles {
        Admin_All, Admin_Department,
        Normal,Self,
        ViewsReport_Department,
        ViewsReport_All
        };